var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "20px",
    width: "20px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M46.6,10.4c-1.2,0.3-3.6,1.1-5.3,1.9C38.7,13.6,36.8,15.2,26,26C15.4,36.7,13.5,38.7,12.3,41.3c-3,6.4-3,13.5,0.3,20.3c1.6,3.3,2.7,4.5,33,34.9L77,128l-31.4,31.4c-34,34.1-33.4,33.5-35,40.1c-1.3,5.5-0.6,11.1,2.1,16.1c1.9,3.7,24.4,26.1,27.9,27.9c4.9,2.5,10.5,3.1,15.8,1.9c6.6-1.6,6-1,40.1-35l31.5-31.4l31.5,31.4c30.3,30.2,31.6,31.5,34.9,33.1c6.5,3.1,13.4,3.3,19.8,0.5c2.7-1.2,4.3-2.6,15.3-13.5c13.2-13.1,14.4-14.7,15.8-20.4c0.9-3.7,0.9-6.8,0-10.5c-1.6-6.6-1-6-35-40.1L178.9,128l31.4-31.5c34-34,33.4-33.4,35-40c1.3-5.8,0.4-11.9-2.5-16.7c-1-1.7-5.8-6.8-13.4-14.3c-9.7-9.6-12.3-11.9-14.6-13c-6.4-3.1-13.6-3.1-20.3,0.1c-3.5,1.6-4.4,2.5-35,33.1L128,77L96.8,45.8C77.6,26.7,64.7,14.2,63.4,13.4C58.4,10.6,51.7,9.4,46.6,10.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.80de795a144673832fb1aab26eeb489e.svg";
export { ForwardRef as ReactComponent };